import { IMAGES } from "./site";

export const BLOG_POSTS = [
    {
        slug: "talentos-que-cambian-historias",
        title: "Talentos que se descubren: procesos que transforman desde adentro",
        excerpt: "Cómo el acceso al arte y la cultura está reescribiendo el futuro de cientos de niños en los barrios populares de Ibagué.",
        date: "2026-01-22",
        author: "Equipo Formar Estructura",
        category: "Impacto",
        image: "https://customer-assets.emergentagent.com/job_formar-estructura/artifacts/epbu6oxw_imagen12v.jpeg",
        imagePosition: "top",
        content: `Durante el último año, más de 1.200 niños y niñas hicieron parte de este camino. A través del arte —la música, la pintura, la danza, el teatro—, pero también desde el refuerzo escolar, el acompañamiento psicosocial y los espacios de integración, fuimos tejiendo algo más profundo que un programa: una experiencia de vida.

Aquí no se trata de intervenir por momentos. Se trata de permanecer, de creer, de estar. De generar entornos donde los niños no solo descubren lo que saben hacer, sino también lo que pueden llegar a ser.

Camila comenzó pintando murales en su barrio. Hoy guía a otros niños y sueña con un futuro distinto. Ese es el verdadero impacto: cuando un proceso se convierte en propósito y una historia empieza a cambiar desde adentro.

En la Fundación Formar Estructura creemos que cada niño es una posibilidad infinita. Nuestro trabajo no es darles un camino, es ayudarles a construir el suyo.`,
    },
    {
        slug: "voluntariado-internacional-tolima",
        title: "Voluntariado internacional: el Tolima como aula del mundo",
        excerpt: "Jóvenes de Alemania, Francia, Brasil y Estados Unidos eligen a Ibagué para vivir una experiencia de intercambio cultural transformadora.",
        date: "2026-01-08",
        author: "Coordinación de Voluntariado",
        category: "Voluntariado",
        image: "https://customer-assets.emergentagent.com/job_formar-estructura/artifacts/hhggwoxt_imagen13v.png",
        content: `Cuando Lukas, de 22 años, llegó desde Hamburgo a Ibagué hace seis meses, no esperaba quedarse. Hoy, al despedirse, dice que se lleva más de lo que entregó. Esta es la magia del voluntariado internacional que coordinamos hace más de una década.

Cada año recibimos voluntarios de más de 5 países que conviven con familias locales, trabajan en nuestros programas y se sumergen en la cultura tolimense. A cambio, comparten con los niños y jóvenes una visión global del mundo: idiomas, costumbres, sueños distintos.

El intercambio funciona en doble vía. Los niños del Tolima descubren que el mundo es ancho y diverso. Los voluntarios entienden que el desarrollo no se mide en cifras, sino en encuentros humanos.

Si eres un joven que busca una experiencia significativa, Ibagué te espera con los brazos abiertos.`,
    },
    {
        slug: "transparencia-confianza-aflora",
        title: "Transparencia: el corazón de nuestra confianza institucional",
        excerpt: "El reconocimiento del programa Aflora de la Fundación Bolívar Davivienda valida nuestro compromiso con la rendición de cuentas.",
        date: "2025-12-15",
        author: "Dirección General",
        category: "Transparencia",
        image: "https://customer-assets.emergentagent.com/job_formar-estructura/artifacts/u530f9a1_imagen14v.JPG",
        content: `La transparencia no es un eslogan. Es una práctica diaria que se sostiene con sistemas, auditorías, informes públicos y, sobre todo, con voluntad institucional.

En el año 2017, Fundación Formar Estructura recibió el reconocimiento del programa Aflora de la Fundación Bolívar Davivienda, una distinción otorgada a organizaciones sin ánimo de lucro que demuestran altos estándares de gobernanza, ética y rendición de cuentas.

Para nosotros, este reconocimiento no es un punto de llegada, sino una invitación a profundizar. Cada peso donado, cada hora voluntaria, cada proyecto, queda documentado y disponible para quien quiera revisarlo. La confianza se construye así.

Invitamos a nuestros donantes, aliados y comunidad a explorar nuestros informes y a hacernos las preguntas difíciles. Esa es la única forma de avanzar juntos.`,
    },
    {
        slug: "encuentros-con-adultos-mayores",
        title: "Cuando las generaciones se encuentran: relatos de los adultos mayores",
        excerpt: "El programa de encuentros intergeneracionales es uno de los más conmovedores. Estas son las historias que nacen allí.",
        date: "2025-11-30",
        author: "Equipo Comunidad",
        category: "Comunidad",
        image: IMAGES.elderly_care,
        content: `Doña Rosario tiene 78 años y aprendió a hacer videollamadas el mes pasado. Lo hizo gracias a una niña de 11 años, Sofía, voluntaria del programa de encuentros intergeneracionales. Ahora hablan todos los miércoles.

Estos encuentros son uno de los proyectos más bellos que coordinamos. Reunimos a adultos mayores —muchos de ellos en situación de soledad— con niños y jóvenes voluntarios. La magia ocurre sola: se cuentan historias, se enseñan recetas, se aprenden tecnologías, se construye memoria.

Lo que descubrimos es que no hay personas vulnerables: hay personas a las que les hemos dado la espalda. Cuando volvemos a mirar, todos crecen.

En 2025 más de 350 adultos mayores participaron del programa. Si quieres ser voluntario en este espacio, te necesitamos.`,
    },
    {
        slug: "navidad-comunitaria-2025",
        title: "Navidad Comunitaria 2025: 5.000 familias unidas por la alegría",
        excerpt: "Un balance del evento más grande del año, donde la comunidad fue protagonista.",
        date: "2025-04-25",
        author: "Equipo Eventos",
        category: "Eventos",
        image: IMAGES.children_community,
        content: `La Navidad Comunitaria 2025 superó todas las expectativas. Más de 5.000 familias se reunieron en un evento que mezcló música, juegos, talleres, regalos y, sobre todo, una sensación profunda de pertenencia.

Lo que hace especial a este evento no son los regalos —aunque entregamos miles—. Es el mensaje: ustedes pertenecen, ustedes importan, ustedes son parte de un nosotros más grande.

Agradecemos a los más de 200 voluntarios, a las marcas aliadas, a los músicos locales, a los padres y abuelos que hicieron posible esta jornada. La fundación es solo el catalizador: la fuerza está en la comunidad.

Nos vemos en 2026 con más sueños compartidos.`,
    },
    {
        slug: "como-empezar-a-donar",
        title: "Cómo empezar a donar (y por qué cada peso cuenta)",
        excerpt: "Una guía clara y honesta sobre las formas de aportar a la Fundación y el impacto real de cada contribución.",
        date: "2025-11-10",
        author: "Equipo Desarrollo",
        category: "Donaciones",
        image: IMAGES.volunteer_painting,
        content: `Donar a una fundación no debería ser un acto de fe. Debería ser una decisión informada, tranquila, sostenible.

En Formar Estructura ofrecemos varias formas de aportar: donaciones únicas vía transferencia bancaria, donaciones recurrentes, aportes en especie, o aportes de tiempo a través del voluntariado. Cada peso, cada hora, cada gesto suma.

Para que tengas claridad: el 87% de nuestros recursos va directamente a programas. El 13% restante cubre administración, comunicaciones y operaciones que hacen sostenible la organización. Esa es nuestra estructura, públicamente disponible.

Si quieres saber a dónde irá tu donación, puedes especificar el programa de tu interés. Y, en cualquier momento, puedes pedir un informe de uso. Esa es la transparencia que practicamos.

Cada peso cuenta. Cada hora cuenta. Cada gesto, también.`,
    },
];

export const findPostBySlug = (slug) => BLOG_POSTS.find((p) => p.slug === slug);
